import moment from 'moment';
import { SUPPORTED_LANGUAGES } from '~/core/constants';

let strings = {};

const DEFAULT_LOCALE = 'en';

const getParentLocale = locale => {
  const [parent, child] = locale.split('-', 2);
  
  return child && parent;
}

const getTranslationFile = async locale => {
  const base = TRANSLATIONS_HOST || window.location.origin;
  const resp = await fetch(`${base}/${locale}.json?v=${APP_VERSION}`);

  if (resp.ok) {
    const json = await resp.json();
    return json;
  }

  return {};
};

export const initTranslate = async locale => {
  moment.locale(locale);

  strings = await getTranslationFile(DEFAULT_LOCALE);

  if (locale === DEFAULT_LOCALE) {
    return;
  }

  if (SUPPORTED_LANGUAGES.includes(locale)) {
    strings = Object.assign(
      strings,
      await getTranslationFile(locale)
    );
  } else {
    const parentLocale = getParentLocale(locale);

    if (parentLocale !== DEFAULT_LOCALE && SUPPORTED_LANGUAGES.includes(parentLocale)) {
      strings = Object.assign(
        strings,
        await getTranslationFile(parentLocale)
      );
    }
  }
};

export const translate = (key, options) => {
  if (!key) {
    return '';
  }

  const data = strings[key];

  if (!data) {
    return `[[${key}]]`;
  }

  const substitute = (match, s) => (
    (options && options[s]) || `{${s}}`
  );

  const result = data.replace(/\{(\w+)\}/g, substitute);

  return result;
};

export default translate;
